import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';

import { RtUICoreOverlayModule } from '../../core/overlay/overlay.module';
import { TooltipModule } from '../tooltip/tooltip.module';
import { IntegrationItemComponent } from './integration-item.component';

@NgModule({
  imports: [
    CommonModule,
    TooltipModule,
    RtUICoreOverlayModule,
    I18nModule,
    IntegrationItemComponent,
  ],
  exports: [IntegrationItemComponent],
})
export class IntegrationItemModule {}
export { IntegrationItemComponent } from './integration-item.component';
